<ui-kit-modal [size]="SizeScheme.Large" (closeClick)="onCloseDialog($event)">
  <ng-template uiKitModalTitle>Downloads</ng-template>

  <ng-template uiKitModalContent>
    <div class="downloads-content" tabindex="-1">
      <ui-kit-tabs>
        @for (group of groups; track group.name) {
          <ui-kit-tab [title]="group.name">
            <div class="download-group-body">
              <div class="download-group-links">
                <span class="download-label">Installation</span>
                @for (link of group.links; track link.name; let last = $last) {
                  <a class="download-link" [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.name }}</a>
                  @if (!last) {
                    <span class="download-separator">|</span>
                  }
                }
              </div>
              <div class="download-group-instructions">
                @for (instruction of group.instructions; track instruction; let i = $index) {
                  <p>({{ i + 1 }}) {{ instruction }}</p>
                }
              </div>
            </div>
          </ui-kit-tab>
        }
      </ui-kit-tabs>
    </div>
  </ng-template>

  <ng-template uiKitModalCloseButton>
    <button uiKitButton theme="filled" color="white">Close</button>
  </ng-template>
</ui-kit-modal>
